import { render, staticRenderFns } from "./TwoLevelProductCategory.vue?vue&type=template&id=33608ee0&scoped=true&"
import script from "./TwoLevelProductCategory.vue?vue&type=script&lang=js&"
export * from "./TwoLevelProductCategory.vue?vue&type=script&lang=js&"
import style0 from "./TwoLevelProductCategory.vue?vue&type=style&index=0&id=33608ee0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33608ee0",
  null
  
)

export default component.exports